<!-- 资源库中心 -->
<template>
	<div class="container" ref="wrap">
		<div class="searchBox">
			<div class="searchInputBox">
				<el-input class="searchInput" :placeholder="$t('home.searchTips')" v-model="formData.keywords">
					<i slot="prefix" class="el-input__icon el-icon-search"></i>
				</el-input>
				<el-button class="searchBtn" style="background-color:#32589f;color:#ffffff;" round @click="searchClick()">{{$t('home.searchBtn')}}</el-button>
			</div>
      <!-- 2022-12-15 不要了-->
			<div hidden class="classifyBox">
				<el-form ref="form" :model="formData" label-width="50px">
				 <div class="formFlexBox">
				 	<div class="rowBox">
						<div class="rowFormBox">
						  <el-form-item :label="$t('resource.type')+ ':' " prop="resource_type">
							<div class="tagsBox">
								<div class="searchTags" :class="formData.resource_type == item.id ? 'active':''" 
								v-for="item,index in resource_type_data" :key="index" @click="(classifyClick('type',item.id),searchClick())">
								{{item.name}}
								</div>
							</div>
						  </el-form-item>
						</div>
						<div class="rowFormBox">
						  <el-form-item :label="$t('resource.format')+ ':' " prop="suffix">
							<div class="tagsBox">
								<div class="searchTags" :class="formData.suffix == item.id ? 'active':''" 
								v-for="item,index in suffixData" :key="index" @click="(classifyClick('format',item.id),searchClick())">
								{{item.name}}
								</div>
							</div>
						  </el-form-item>
						</div>
				 	</div>
					<el-form-item :label="$t('resource.date')+ ':' " prop="dateTime" style="margin-bottom: 0;">
						<el-date-picker
						  v-model="formData.dateTime"
						  type="daterange"
						  align="right"
						  unlink-panels
						  :range-separator="$t('resource.to')"
						  :start-placeholder="$t('resource.startDate')"
						  :end-placeholder="$t('resource.endDate')"
						  value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>
				 </div>
				</el-form>
			</div>
		</div>
		<div class="contentBox">
			<el-row :gutter="30">
			<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" v-for="item,index in pageData" :key="index" style="margin: 10px 0;">
				<div class="resourceBox" @click="goDetailPage(item.id)">
					<el-image class="resourceListImg" :src="item.pic_url" fit="cover">
					</el-image>
					<div class="resourceContentBox">
						<div class="resourceTitle">{{item.title}}</div>
						<div class="resourceDesc">{{item.remark}}</div>
					</div>
					<div class="resourceContentDetileBox">
						<div class="resourceTitle">{{item.title}}</div>
						<div class="detileDesc">{{item.remark}}</div>
					</div>
				</div>
			</el-col>
			</el-row>
			<!-- 分页 -->
			<div class="paginationBox" v-if="formData.totalPages > 0">
				<el-pagination background layout="prev, pager, next" 
				:pager-count="5"
				:current-page="formData.page"
				:total="formData.totalPages" @current-change="currentPageChange"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import { localStorage } from '@/utils/storage.js'
	import { formatTimeNum } from '@/utils'
	import * as resource from '@/api/resource'
	
	export default {
    name: 'ResourceLibrary',
    data() {
		return {
      pickerOptions: {
        shortcuts: [{
        text: '最近一周',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', [start, end]);
        }
        }, {
        text: '最近一个月',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit('pick', [start, end]);
        }
        }, {
        text: '最近三个月',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit('pick', [start, end]);
        }
        }]
      },
			// 搜索模块
			formData: {
				keywords: '',
				resource_type: '',
				suffix: '',
				dateTime: '',
				begin: '',
				end: '',
				page: 1,
				size: 12,
			},
			resource_type_data: [
				{id: '',name: '全部'},
				{id: 1,name: '训练资源'},
				{id: 2,name: '维护资源'},
				{id: 3,name: '信技资源'},
				{id: 4,name: '科创资源'},
			],
			suffixData: [
				{id: '',name: '全部'},
				{id: '.doc',name: 'doc'},
				{id: '.pdf',name: 'pdf'},
				{id: '.ppt',name: 'ppt'},
				{id: '.xls',name: 'xls'},
				{id: '.txt',name: 'txt'},
			],
			pageData: [],
		};
    },
    mounted() {
      const lang = localStorage.get('language')
      if(lang == 'en'){
        this.resource_type_data = [
          {id: '',name: 'All'},
          {id: 1,name: 'Pedagogical'},
          {id: 2,name: 'Train'},
          {id: 3,name: 'Safeguard'},
          {id: 4,name: 'View'},
        ]
        this.suffixData = [
          {id: '',name: 'All'},
          {id: '.doc',name: 'doc'},
          {id: '.pdf',name: 'pdf'},
          {id: '.ppt',name: 'ppt'},
          {id: '.xls',name: 'xls'},
          {id: '.txt',name: 'txt'},
        ]
      }
      this.getPageList();
    },
    methods:{
		classifyClick(type,index){
			if(type == 'type'){
				this.formData.resource_type = index
			}else if(type == 'format'){
				this.formData.suffix = index
			}
		},
		// 分页
		currentPageChange(e){
			;
			this.formData.page = e
			this.getPageList();
		},
		// 搜索
		searchClick(){
			this.formData.page = 1
			this.getPageList();
		},
		// 获取资源中心列表
		getPageList(){
			let para = this.formData
				para.begin = para.dateTime[0]
				para.end = para.dateTime[1]
			resource.index(para).then(response => {
        if(response.code == 0){
				 this.formData.currentPage = response.data.currentPage  //当前页数
				 this.formData.totalPages = response.data.totalPages //总页数
          this.pageData = response.data.data
        }
			}).catch((res) => {
        ;
			})
		},
		// 查看详情
		goDetailPage(id){
			;
			this.$router.push({
				path:'/resourceCenterDetail',
				query: { id: id },
			})
			this.$emit("resetScrollTop")
		},
    }
	}
</script>
<style>
	.searchInput .el-input__inner{
		border-radius: 80px;
		padding-left: 40px;
	}
	.searchInput .el-input__prefix{
		left: 10px;
	}
</style>
<style scoped>
	/* 搜索模块 */
	.searchBox{
		width: 75%;
		padding-top: 30px;
		margin: 0 auto;
		box-sizing: border-box;
	}
	.searchInputBox{
		width: 100%;
		display: flex;
		align-items: center;
	}
	.searchInput{
		width: 40%;
		border-radius: 80px;
		margin-right: 20px;
	}
	.searchBtn{
		padding: 12px 40px;
		font-size: 16px;
	}
	.classifyBox{
		padding-top: 20px;
	}
	.formFlexBox{
		width: 100%;
	}
	.rowBox{
		width: 100%;
		display: flex;
		align-items: center;
	}
	.rowFormBox{
		max-width: 50%;
		box-sizing: border-box;
		padding-right: 10px;
	}
	.rowFormBox:last-child{
		padding-left: 10px;
		padding-right: 0;
	}
	.searchTags{
		cursor: pointer;
		background-color: #ffffff;
		border-color: #E4E7ED;
		height: 32px;
		padding: 0 10px;
		line-height: 30px;
		font-size: 12px;
		border-width: 1px;
		border-style: solid;
		border-radius: 4px;
		box-sizing: border-box;
		white-space: nowrap;
		margin: 5px;
	}
	.searchTags.active{
		border-color: #409EFF;
		background: #ecf5ff;
		color: #409EFF;
	}
	.tagsBox{
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
	
	/*  */
	.swiperSlideImg{
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.contentBox{
		width: 75%;
		padding: 30px 0;
		margin: 0 auto;
	}
	.resourceBox{
		width: 100%;
		min-height: 300px;
		box-shadow: 0 0 8px #C0C4CC;
		overflow: hidden;
		cursor: pointer;
		position: relative;
	}
	.resourceBox:hover .resourceListImg{
		opacity: 0.9;
	}
	.resourceListImg{
		width: 100%;
		height:300px;
		object-fit: cover;
		transition: all .3s;
	}
	.resourceContentBox{
		width: 100%;
		box-sizing: border-box;
		padding: 20px;
	}
	.resourceTitle{
		color: #333333;
		font-size: 18px;
		font-weight: bold;
		padding: 0 0 20px;
	}
	.resourceDesc{
		width: 100%;
		min-height: 94px;
		line-height: 2.2;
		color: #333333;
		font-size: 14px;
		display: -webkit-box;
		overflow: hidden;
		/*! autoprefixer: off; */     
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
	}
	.resourceContentDetileBox{
		width: 100%;
		min-height: 230px;
		box-sizing: border-box;
		padding: 20px;
		position: absolute;
		bottom: 0;
		left: 0;
		background: #32589f;
		opacity: 0;
		transition: all .3s;
	}
	.resourceBox:hover .resourceContentDetileBox{
		opacity: 1;
	}
	.resourceContentDetileBox .resourceTitle{
		color: #ffffff;
	}
	.detileDesc{
		width: 100%;
		line-height: 2.2;
		color: #ffffff;
		font-size: 14px;
		display: -webkit-box;
		overflow: hidden;
		/*! autoprefixer: off; */     
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 6;
	}
	/* 分页 */
	.paginationBox{
		width: 100%;
		box-sizing: border-box;
		padding: 40px 10px 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	/* 响应式样式 */
	@media only screen and (max-width: 768px) {
	  .searchBox{
		width: 90%;
		padding-top: 10px;
	  }
	  .classifyBox{
		  padding-top: 10px;
	  }
	  .contentBox{
	  	width: 90%;
		padding: 10px 0;
	  }
	  .resourceBox:hover .resourceContentDetileBox{
	  	opacity: 0;
	  }

	  .resourceDesc{
		display: inherit;
		-webkit-box-orient: inherit;
		-webkit-line-clamp: inherit;
		}
	  .swiperSlideImg{
		  height: 200px;
	  }
	  /* 搜索 */
	  .searchInput{
		  width: auto;
		  flex-grow: 1;
		  margin-right: 10px;
	  }
	  .searchBtn{
		  font-size: 14px;
		  padding: 10px 25px;
	  }
	  .rowBox{
		  display: block;
	  }
	  .rowFormBox{
		  max-width: 100%;
		  padding: 0;
	  }
	  .rowFormBox:last-child{
		  padding: 0;
		  margin-bottom: 10px;
	  }
	  .el-form-item{
		margin-bottom: 0px;  
	  }
	  
	  .formFlexBox /deep/ .el-range-editor.el-input__inner{
		  width: 100%;
	  }
	  
	  /*  */
	  
	}
	
	@media screen and (min-width: 768px) { 
		
	}
	@media screen and (min-width: 992px) {  }
	
	@media screen and (min-width: 1200px) {  }
	
	@media screen and (min-width: 1400px) {  }
	
	@media screen and (min-width: 1920px) {  }
</style>